// Drop-in PayFast "Pay Now" button for the R15 entry-level CV.
// Mirrors the exact form PayFast generates in their merchant dashboard
// (action https://www.payfast.co.za/eng/process, receiver 35736199),
// with the same custom-quantity multiplier behaviour.
export function PayFastR15CvButton() {
  function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    const form = e.currentTarget;
    const amount = form.elements.namedItem("amount") as HTMLInputElement | null;
    const qty = form.elements.namedItem("custom_quantity") as HTMLInputElement | null;
    if (!amount || !qty) return;
    const unit = parseFloat(amount.defaultValue || "15");
    const q = Math.max(1, parseInt(qty.value || "1", 10));
    amount.value = (unit * q).toFixed(2);
    // allow the native POST to PayFast
  }

  return (
    <form
      onSubmit={onSubmit}
      name="PayFastPayNowForm"
      action="https://www.payfast.co.za/eng/process"
      method="post"
      className="rounded-2xl border border-border bg-card p-5 shadow-soft"
    >
      <p className="text-xs uppercase tracking-widest text-gold">Entry-level CV</p>
      <h3 className="mt-1 font-display text-xl text-navy">R15 — Pay &amp; download</h3>
      <p className="mt-1 text-xs text-muted-foreground">
        Perfect for first-time job seekers and entry-level retail, hospitality,
        customer service, general work or part-time roles.
      </p>

      <input required type="hidden" name="cmd" value="_paynow" />
      <input required type="hidden" name="receiver" pattern="[0-9]" value="35736199" />
      <input required type="hidden" name="item_name" maxLength={255} value="CV -R15" />
      <input
        type="hidden"
        name="item_description"
        maxLength={255}
        value="Perfect for first-time job seekers and anyone applying for entry-level positions in retail, hospitality, customer service, general work, or part-time roles."
      />

      <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
        <label className="flex flex-col gap-1">
          <span className="text-xs text-muted-foreground">Amount (R)</span>
          <input
            required
            id="PayFastAmount"
            type="number"
            step=".01"
            name="amount"
            min="5.00"
            placeholder="5.00"
            defaultValue="15"
            className="rounded-md border border-input bg-background px-3 py-2"
          />
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-xs text-muted-foreground">Quantity</span>
          <input
            required
            id="custom_quantity"
            type="number"
            name="custom_quantity"
            min={1}
            defaultValue={1}
            className="rounded-md border border-input bg-background px-3 py-2"
          />
        </label>
      </div>

      <button
        type="submit"
        className="mt-4 inline-flex w-full items-center justify-center"
        aria-label="Buy R15 CV with PayFast"
      >
        <img
          src="https://my.payfast.io/images/buttons/BuyNow/Primary-Large-BuyNow.png"
          alt="Buy Now with PayFast — pay R15 for your ATS CV by card, EFT or instant EFT"
          title="Buy Now with PayFast"
        />
      </button>
    </form>
  );
}
